import { render, staticRenderFns } from "./salePersonTask.vue?vue&type=template&id=6509d266&scoped=true&"
import script from "./salePersonTask.vue?vue&type=script&lang=js&"
export * from "./salePersonTask.vue?vue&type=script&lang=js&"
import style0 from "./salePersonTask.vue?vue&type=style&index=0&id=6509d266&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6509d266",
  null
  
)

export default component.exports